import { render, staticRenderFns } from "./businessCard.vue?vue&type=template&id=11198b20&"
import script from "./businessCard.vue?vue&type=script&lang=js&"
export * from "./businessCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports